import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';

export const featuredDocsWidget = HomePageWidgetBlueprint.make({
  name: 'featured-docs',
  params: {
    title: 'Featured Documentation',
    description: 'Documentation tagged as featured',
    components: async () => {
      const { FeaturedDocsCard } = await import('@backstage/plugin-home');
      return {
        Content: () => (
          <FeaturedDocsCard
            filter={{
              'spec.type': 'documentation',
              'metadata.tags': 'featured',
            }}
          />
        ),
      };
    },
    layout: {
      width: { defaultColumns: 6 },
      height: { defaultRows: 4 },
    },
  },
});

export const toolkitWidget = HomePageWidgetBlueprint.make({
  name: 'vorwerk-toolkit',
  params: {
    title: 'Toolkit',
    description: 'Quick links to commonly used tools',
    components: async () => {
      const { HomePageToolkit } = await import('@backstage/plugin-home');
      const {
        ArgoCdIcon,
        ConfluenceIcon,
        GitLabIcon,
        GrafanaIcon,
        HarborIcon,
        JenkinsIcon,
        JiraIcon,
        MiroIcon,
        SlackIcon,
        SnykIcon,
      } = await import('../../assets/icons/customIcons');
      return {
        Content: () => (
          <HomePageToolkit
            tools={[
              {
                url: 'https://eu.argocd.prod.cookidoo.vorwerk-digital.com/',
                label: 'ArgoCD',
                icon: <ArgoCdIcon />,
              },
              {
                url: 'https://cookidoo.grafana.net/',
                label: 'Cookidoo Grafana',
                icon: <GrafanaIcon />,
              },
              {
                url: 'https://jenkins.tes-build-prod.cookidoo.vorwerk-digital.com/',
                label: 'Embedded Jenkins',
                icon: <JenkinsIcon />,
              },
              {
                url: 'https://gitlab.tmecosys.net/',
                label: 'GitLab',
                icon: <GitLabIcon />,
              },
              {
                url: 'https://harbor.tools.vorwerk-digital.com/',
                label: 'Harbor',
                icon: <HarborIcon />,
              },
              {
                url: 'https://app.snyk.io/',
                label: 'Snyk',
                icon: <SnykIcon />,
              },
              {
                url: 'https://vorwerkproducts.atlassian.net/jira',
                label: 'Jira',
                icon: <JiraIcon />,
              },
              {
                url: 'https://vorwerkproducts.atlassian.net/wiki',
                label: 'Confluence',
                icon: <ConfluenceIcon />,
              },
              {
                url: 'https://miro.com/app/dashboard/',
                label: 'Miro',
                icon: <MiroIcon />,
              },
              {
                url: 'https://vorwerkdigital.enterprise.slack.com/',
                label: 'Slack',
                icon: <SlackIcon />,
              },
            ]}
          />
        ),
      };
    },
    layout: {
      width: { defaultColumns: 6 },
      height: { defaultRows: 4 },
    },
  },
});

export const starredEntitiesWidget = HomePageWidgetBlueprint.make({
  name: 'starred-entities',
  params: {
    title: 'Starred Entities',
    description: 'Your starred entities from the catalog',
    components: async () => {
      const { HomePageStarredEntities } = await import(
        '@backstage/plugin-home'
      );
      return {
        Content: () => <HomePageStarredEntities groupByKind />,
      };
    },
    layout: {
      width: { defaultColumns: 6 },
      height: { defaultRows: 4 },
    },
  },
});
